// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"DistributionCurve_content-wrapper__1jwLj","tableBelow":"DistributionCurve_table-below__3lptH"};